export const editorToolbarConfig = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
];
